// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/Users/usuario/ggseco/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/usuario/ggseco/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/usuario/ggseco/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/Users/usuario/ggseco/.cache/json/404.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/usuario/ggseco/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/usuario/ggseco/.cache/json/index.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/usuario/ggseco/.cache/json/layout-index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/Users/usuario/ggseco/.cache/json/404-html.json")
}

exports.layouts = {
  "component---src-layouts-index-js": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/usuario/ggseco/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js